module.exports = __webpack_public_path__ + "img/0-18.6c71d93e.jpg";